import { NgModule } from '@angular/core';
import { ToggleModule } from './components/toggle/toggle.module';
import { ModalsModule } from './components/modals/modals.module';
import { AvatarImageModule } from './components/avatar/avatar-image.module';
import { TranslateModule } from '@ngx-translate/core';
import { WeekDayTranslatePipe } from './pipes/week-day-translate.pipe';
import { SpaceFeaturesModule } from './components/space-features/space-features.module';
import { CommonModule } from '@angular/common';
import { ModalModule as DDSModalModule } from '@usitsdasdesign/dds-ng/modal';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InofficeVirtualToggleComponent } from './components/inoffice-virtual-toggle/inoffice-virtual-toggle.component';
import { TimepickerModule } from '@usitsdasdesign/dds-ng/timepicker';
import { OwnerSearchModule } from './components/owner-search/owner-search.module';
import { MomentPipeModule } from './pipes/moment/moment-pipe.module';
import { DataTableModule } from './components/data-table/data-table.module';
import { StatusModule } from './components/status/status.module';
import { RouterModule } from '@angular/router';
import { MultiSelectModule } from './components/multi-select/multi-select.module';
import { SpecialistDetailsModule } from './components/specialist-details/specialist-details.module';
import { EllipsisTooltipModule } from './directives/ellipsis-tooltip/ellipsis-tooltip.module';
import { HighlightModule } from './common/highlight/highlight.module';
import { ReadOnlyModule } from './components/read-only/read-only.module';
import { MergeTimepickerModule } from './components/merge-timepicker/merge-timepicker.module';
import { VirtualOptionModule } from './virtul-options/virtual-option.module';
import { TagsModule } from './components/tags/tags.module';
import { CheckboxModule } from './components/checkbox/checkbox.module';
import { TooltipModule } from './components/tooltip/tooltip.module';
import { SelectModule } from './components/select/select.module';

import { InputModule } from './components/input/input.module';
import { TextareaModule } from './components/textarea/textarea.module';
import { ButtonModule } from './components/button/button.module';
import { NumberedPaginationModule } from './components/numbered-pagination/numbered-pagination.module';

@NgModule({
  imports: [
    ButtonModule,
    ToggleModule,
    ModalsModule,
    SelectModule,
    DDSModalModule,
    AvatarImageModule,
    TranslateModule,
    SpaceFeaturesModule,
    FormsModule,
    ReactiveFormsModule,
    TimepickerModule,
    CommonModule,
    OwnerSearchModule,
    InputModule,
    TextareaModule,
    MomentPipeModule,
    DataTableModule,
    StatusModule,
    RouterModule,
    HighlightModule,
    SpecialistDetailsModule,
    EllipsisTooltipModule,
    MomentPipeModule,
    ReadOnlyModule,
    MergeTimepickerModule,
    TagsModule,
    TooltipModule,
    NumberedPaginationModule
  ],
  exports: [
    ButtonModule,
    ToggleModule,
    ModalsModule,
    AvatarImageModule,
    WeekDayTranslatePipe,
    SpaceFeaturesModule,
    FormsModule,
    ReactiveFormsModule,
    InofficeVirtualToggleComponent,
    InputModule,
    TextareaModule,
    CheckboxModule,
    MultiSelectModule,
    SpecialistDetailsModule,
    ReadOnlyModule,
    TranslateModule,
    VirtualOptionModule,
    MergeTimepickerModule,
    TagsModule,
    SelectModule,
    NumberedPaginationModule
  ],
  declarations: [
    WeekDayTranslatePipe,
    InofficeVirtualToggleComponent,
  ],
  //  declarations: [ReadOnlyComponent, WeekDayTranslatePipe,CancelModalComponent, ExpandableCardComponent,InofficeVirtualToggleComponent, RoomfeatureComponent],
  providers: [WeekDayTranslatePipe],
})
export class SharedModule { }
